import React from "react";
import breathfree from "../assets/articale/woman holding gut.jpg";
import cross from "../assets/cross.webp";

const SlimeticsFreely = () => {
  return (
    <div>
      <h2 className="text-3xl font-bold text-[#303030] mb-6">
      Thousands Are Turning to This Gut Support Formula to Feel Better, Naturally
      </h2>
      <div className="relative w-full mb-6">
        <img
          src={breathfree}
          alt="Lung diagram with surrounding bacterial images"
          className="w-full rounded-3xl border border-gray-100"
          draggable="false"
        />
      </div>
      <div className="space-y-4 text-[#303030]">
      <p>And now, you can too.</p>
        <p>
          <span className="  font-bold"> {"Imagine This…"}</span>
        </p>
        <div className="bg-[#e2f4f9] p-4">
          <div className="flex items-center gap-3 mb-4 last:mb-0">
            <div className="flex-shrink-0">
              <img src={cross} alt="" className="h-8 w-8" draggable="false" />
            </div>
            <p className="text-[#303030] font-bold">
              {" Less bloating, gas, and discomfort"}
            </p>
          </div>
          <div className="flex items-center gap-3 mb-4 last:mb-0">
            <div className="flex-shrink-0">
              <img src={cross} alt="" className="h-8 w-8" draggable="false" />
            </div>
            <p className="text-[#303030] font-bold">
              {"Fewer cravings that feel impossible to control"}
            </p>
          </div>
          <div className="flex items-center gap-3 mb-4 last:mb-0">
            <div className="flex-shrink-0">
              <img src={cross} alt="" className="h-8 w-8" draggable="false" />
            </div>
            <p className="text-[#303030] font-bold">
              {"No more feeling stuck in a cycle of fatigue and frustration"}
            </p>
            
          </div>

          <div className="flex items-center gap-3 mb-4 last:mb-0">
            <div className="flex-shrink-0">
              <img src={cross} alt="" className="h-8 w-8" draggable="false" />
            </div>
            <p className="text-[#303030] font-bold">
              {"A lighter, more energized version of yourself"}
            </p>
            
          </div>
        </div>
        <p>
        All of this is possible when your gut is supported.
        </p>
        <p class="font-bold">{"Here’s the Best Part:"}</p>
        <p>
        Taking Slimetics takes just a few seconds a day—yet it can help support real, noticeable change from the inside out.
        </p>
        <p>
        Just one capsule daily is all it takes to help your gut and metabolism work in harmony.
        </p>
       
      </div>
    </div>
  );
};

export default SlimeticsFreely;
